import type { RoomEnhancementOption, RoomOffers } from '~~/domains/graphql';

export type PriceItem = {
  pricing: { amount: { afterTax?: number; hotelKeeper?: number } };
};

export function getPrice(
  areAllTaxesIncluded: boolean,
  item?: PriceItem | null,
) {
  return areAllTaxesIncluded
    ? item?.pricing?.amount?.afterTax ?? 0
    : item?.pricing?.amount?.hotelKeeper ?? 0;
}

export function getOfferPrice(
  areAllTaxesIncluded: boolean,
  offer?: RoomOffers | null,
): number {
  return getPrice(areAllTaxesIncluded, offer as PriceItem);
}

export function getOptionPrice(
  areAllTaxesIncluded: boolean,
  option?: RoomEnhancementOption | null,
): number {
  return getPrice(areAllTaxesIncluded, option as PriceItem);
}
